import { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { ref, set } from "firebase/database";
import { auth, database } from "../firebase/firebase";
import AdminMenu from "../components/AdminMenu";

export default function CreateUser(){

const [username,setUsername] = useState("")
const [password,setPassword] = useState("")

const createUser = async () => {

try{

const email = username + "@jauhari.webtech";

const userCredential =
await createUserWithEmailAndPassword(auth,email,password);

const uid = userCredential.user.uid;

await set(ref(database,"system/users/"+uid),{

username: username,
email: email,
role: "client",
active: true

});

alert("User created successfully");

}catch(error){

if(error.code === "auth/email-already-in-use"){

alert("This username already exists.");

}else{

alert(error.message);

}

}

}
return(

<div>

<AdminMenu/>

<div className="container">

<h2>Create User</h2>

<input
placeholder="Username"
onChange={(e)=>setUsername(e.target.value)}
/>

<input
type="password"
placeholder="Password"
onChange={(e)=>setPassword(e.target.value)}
/>

<button onClick={createUser}>
Create User
</button>

</div>

</div>

)

}